import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_COMMS_STACK_DM_ADDED_ENGAGEMENT_VALUE_PROPS_ENABLED = createFcmDetails(
	'comms_stack_dm_added_engagement_value_props_enabled',
	{
		owner: 'Campaign Squad',
		context: 'Allow sending new email template when a decision maker is added',
		import: false,
		description: `Upon adding a decision maker, a new email template with some value propositions has been created.
			This FC permits switching between the old and new template. FC should be enabled by country. Locale preferences should set within the "supportedLocales" property`,
		template: {
			enabled: false,
			supportedLocales: ['en-US'],
		},
	},
);
